import React, { useEffect } from 'react';
import { translator, web, writer } from '../../assets/Assets';
import gsap from 'gsap';
import './MyServices.scss';

function MyServices() {
  useEffect(() => {
    gsap.from('.services h1', {
      y: '-14vw',
      duration: 1,
    });
  }, []);
  return (
    <section className="services">
      <div className="box">
        <h1>
          Services <hr />
        </h1>
      </div>
      <div className="service-list">
        <div>
          <h3>Web Development</h3>
          <img src={web} alt="webDev" />
          <p>Front End / Design to code</p>
        </div>
        <div>
          <h3>SEO Content Writing</h3>
          <img src={writer} alt="writer" />
          <p>Indonesia or English language</p>
        </div>
        <div>
          <h3>Native Translator</h3>
          <img src={translator} alt="translator" />
          <p>English &#8592;&#8594; Indonesia </p>
        </div>
      </div>
    </section>
  );
}

export default MyServices;
